import colors from 'globals/colors'
import measures from 'globals/measures'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const RememberMe = styled.div`
  margin-top: 14px;
  margin-bottom: 21px;
  flex-basis: 100%;

  @media (max-width: ${measures.mobileThreshold}px) {
    margin-bottom: 70px;
  }
`

export const ForgotCredentialsLink = styled(Link)`
  line-height: 15px;
  color: ${colors.waterBlue};
  font-size: 13px;
  text-decoration: underline;
  margin-top: 17px;
  flex-basis: 100%;
`
